import { render, staticRenderFns } from "./VideoPlayerModal.vue?vue&type=template&id=623000cc&"
import script from "./VideoPlayerModal.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports